import CompanyOffersTab from 'src/components/pages/Company/CompanyPage/CompanyOffersTab/CompanyOffersTab';

export default CompanyOffersTab;
